import { CheckCircle2, WifiOff } from "lucide-react";
import type { ReactNode } from "react";

export function LoadingState({ label = "Carregando…" }: { label?: string }) {
  return (
    <div className="state-block" role="status">
      {label}
    </div>
  );
}

export function ErrorState({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}) {
  return (
    <div className="state-block state-block--error" role="alert">
      <WifiOff className="icon" size={24} aria-hidden="true" />
      <strong>Não foi possível carregar os dados.</strong>
      <span>{message}</span>
      {onRetry && (
        <button type="button" className="btn btn--secondary btn--sm" onClick={onRetry}>
          Tentar de novo
        </button>
      )}
    </div>
  );
}

export function EmptyState({
  title,
  description,
  action,
  /** Estado vazio "de sucesso" (ex.: fila do dia zerada) — badge circular
   * grande verde com CheckCircle2 em vez de so uma frase. */
  celebratory,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  celebratory?: boolean;
}) {
  return (
    <div className={`state-block${celebratory ? " state-block--celebratory" : ""}`}>
      {celebratory && (
        <span className="state-celebratory__badge" aria-hidden="true">
          <CheckCircle2 size={28} />
        </span>
      )}
      <strong>{title}</strong>
      {description && <span>{description}</span>}
      {action}
    </div>
  );
}
